// removed by extract-text-webpack-plugin
module.exports = {"wrapperContainer":"_3KmhFMbxer4Bs8GNWyISxG","mainContainer":"_3OEF1iCDJq4nM-U_TBTVNk","orange":"_2Aj19HZxesclvDw0xgtsO_","red":"_21lWJIl06UbB_xS3y1qeN4","racers":"jlWHfvue1HdNALG1cFMwg","racerIconContainer":"_3svH5zuHuS15exzTQvifBw","racerNumber":"_3kuNysNU3f0sTKcLZmTQ6s","racerIcon":"_16UBvQjQ6WPkmikvVbMQd3"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/sharedComponents/css/messageBar.css
// module id = 1019
// module chunks = 0